import type { AppStore } from "@/store/AppStore";
import { AiToolkitCollectionNotFoundError } from "@/modules/ai-toolkit/errors";
import type {
  NavigateToCollectionInput,
  NavigateToCollectionOutput,
} from "@mem-client/ai-toolkit/contract";
import {
  AiToolkitToolName,
  navigateToCollectionInputSchema,
  navigateToCollectionOutputSchema,
} from "@mem-client/ai-toolkit/contract";
import type { AiToolkitToolDefinition } from "@/modules/ai-toolkit/tools/types";

export const navigateToCollection = async ({
  store,
  input,
}: {
  store: AppStore;
  input: NavigateToCollectionInput;
}): Promise<NavigateToCollectionOutput> => {
  const collection = await store.collections.getAsync(input.collectionId);

  if (!collection) {
    throw new AiToolkitCollectionNotFoundError({ collectionId: input.collectionId });
  }

  store.navigation.goToCollection({
    collectionId: input.collectionId,
    openInSameTab: input.openInSameTab ?? true,
  });

  return {
    navigated: true,
    collectionId: input.collectionId,
  };
};

export const navigateToCollectionTool: AiToolkitToolDefinition<
  AiToolkitToolName.NavigateToCollection,
  NavigateToCollectionInput,
  NavigateToCollectionOutput
> = {
  name: AiToolkitToolName.NavigateToCollection,
  inputSchema: navigateToCollectionInputSchema,
  outputSchema: navigateToCollectionOutputSchema,
  strict: true,
  execute: navigateToCollection,
};
